import request from '@/api/request'



//PC工作台-
export function reportSetLists(data) {
    return request({
        url: '/api/director/reportSet/lists',
        method: 'GET',
        params: data
    })
}



//PC工作台-
export function reportSetEditInfo(data) {
    return request({
        url: '/api/director/reportSet/info',
        method: 'GET',
        params: data
    })
}


//PC工作台-设置打卡修改
export function updateReportSet(data) {
    return request({
        url: '/api/director/reportSet/edit',
        method: 'POST',
        data
    })
}


//PC工作台-ADD设置打卡
export function addReportSet(data) {
    return request({
        url: '/api/director/reportSet/add',
        method: 'POST',
        data
    })
}




//PC工作台-打卡设置删除
export function reportSetDel(data) {
    return request({
        url: '/api/director/reportSet/del',
        method: 'POST',
        data
    })
}



